<div class="tires-column flex flex-row justify-between items-center gap-[5px] w-full">
  <div class="flex flex-row items-center gap-1">
    <rfc-icon [iconInput]="summerIcon" class="icon block shrink-0"></rfc-icon>
    <span class="text-xs font-normal leading-none">{{ tires.summer }}</span>
  </div>

  <div class="flex flex-row items-center gap-1">
    <rfc-icon [iconInput]="winterIcon" class="icon block shrink-0"></rfc-icon>
    <span class="text-xs font-normal leading-none">{{ tires.winter }}</span>
  </div>
</div>